var activeKeys = []; // array to store currently pressed keys
var tabCode = 9;
var shiftCode = 16;
var fCode = 70;

$( document ).on('keydown', function (e) {

	// add pressed key to activeKeys array
	if ( activeKeys.indexOf(e.which) == -1 )
	{
		activeKeys.push( e.which );
	}

	// disable consecutive tab-to-next behaviour ( we do this because we want to create/enable/use key shortcuts using tab + [insert_key_here] )
    /*if ( getActiveKeys(1, [tabCode]) ) { // if pressing tab
        if (
        	( typeof e.originalEvent.repeat != undefined && typeof e.originalEvent.repeat != 'undefined' && e.originalEvent.repeat ) || 
        	( typeof e.repeat != undefined && typeof e.repeat != 'undefined' && e.repeat )
        ) {
        	e.preventDefault();
        }
    } else */if ( getActiveKeys(2, [shiftCode, tabCode]) ) { // if pressing shift+tab, do nothing special (this is only here to prevent going to next 'else if' on shift+tab)

    } else if ( getActiveKeys(2, [tabCode]) || getActiveKeys(3, [tabCode]) ) { // if pressing tab+someKey or tab+someKey+someKey
    	e.preventDefault();
    }

    if ( getActiveKeys( 2, [tabCode, fCode] ) ) { // tab+f = search
    	toggleSearch();
    }

    // wink
    if ( getActiveKeys(6, []) )
    {
    	if ( $('#donnaPopup').length == 0 )
    	{
    		$( 'body' ).append(
				'<div id="donnaPopup" style="background-color: rgba(0, 0, 0, .7); width: 100%; height: 100%; position: fixed; top: 0; left: 0; display: flex; align-items: center; justify-content: center; z-index: 9999;">' + 
					// '<img src="' + PHPUrls.baseUrl + '/assets/img/donna/tease.gif?t=' + new Date().getTime() + '">' +
					'<img src="' + './assets/img/donna/tease.gif?t=' + new Date().getTime() + '">' +
				'</div>'
			)
			setTimeout(function()
			{
				console.log( $('#donnaPopup').length );
				if ( $('#donnaPopup').length ) {
					$('#donnaPopup').remove();
				}
			}, 1950); // 1950 length of anim
			
			event.preventDefault();
    	}
    }

});

// wink r
$( document ).on('click touchstart', function(event)
{
	if ( $('#donnaPopup').length )
	{
		$( '#donnaPopup' ).remove();
	}
});

// delete released key from activeKeys array
$( document ).on('keyup', function (e)
{
	var index = activeKeys.indexOf( e.which );
	if ( index != -1 )
	{
		activeKeys.splice( index, 1 );
	}
});

// reset activeKeys array on window blur
$( window ).on('blur', function(event)
{
	activeKeys = [];
});

/*
 * check if x number of keys (length) are pressed and if array of keys (keyArray) are currently pressed
 * @param length (INT, required)
 * @param keyArray (array of keyCodes, required)
 * @return boolean
 * by ole fjarestad and simen eira
 */
function getActiveKeys ( length, keyArray )
{
	
	if ( activeKeys.length != length )
	{
		return false;
	}

	for ( var i = 0; i < keyArray.length; ++i )
	{
		if ( activeKeys.indexOf(keyArray[i]) == -1 )
		{
			return false;
		}
	}

	return true;

}

/*
 * toggle site wide search
 * by ole fjarestad
 */
function toggleSearch ()
{

	var $searchInput = $( '#searchInput' );

	if ( $searchInput.hasClass('isSearching') )
	{
		$searchInput.removeClass( 'isSearching' );
		$searchInput.blur();
	}
	else
	{
		$searchInput.addClass( 'isSearching' );
		$searchInput.focus();
	}

}



//////////////////
// WEBPACK FOOTER
// ./src/assets/js/partials/keyboard-shortcuts.js
// module id = ./src/assets/js/partials/keyboard-shortcuts.js
// module chunks = main